module.exports = __webpack_public_path__ + "img/New PACI Flow - New-4.db2c3f1a.png";